import { mjtiContent } from "../mjtiContent";
import MjtiSignupForm from "./MjtiSignupForm";

export default function MjtiLanding() {
  const c = mjtiContent;
  return (
    <div className="mjti-page">
      <div className="mjti-container">
        <section className="mjti-hero">
          <div className="mjti-hero__eyebrow">{c.hero.eyebrow}</div>
          <h1 className="mjti-hero__headline landing-serif">{c.hero.headline}</h1>
          {c.hero.body.map((para, i) => (
            <p key={i} className="mjti-hero__body">{para}</p>
          ))}
        </section>
      </div>

      <section className="mjti-screenshots-section" aria-label="Inside MahjSpace">
        <div className="mjti-screenshots-inner">
          {c.screenshots.map((s, i) => (
            <figure key={i} className="mjti-screenshot">
              <div className="mjti-screenshot__frame">
                <img src={s.src} alt={s.alt} />
              </div>
              <figcaption className="mjti-screenshot__caption">{s.caption}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      <div className="mjti-container">
        <section className="mjti-benefits">
          <h2 className="mjti-benefits__heading landing-serif">{c.benefits.heading}</h2>
          <ul className="mjti-benefits__list">
            {c.benefits.items.map((item, i) => (
              <li key={i} className="mjti-benefits__item">{item}</li>
            ))}
          </ul>
        </section>

        <section id="mjti-signup" className="mjti-signup">
          <h2 className="mjti-signup__heading landing-serif">{c.signupForm.heading}</h2>
          <MjtiSignupForm />
        </section>
      </div>

      <footer className="mjti-footer">
        <div className="mjti-container">
          <img
            src={process.env.PUBLIC_URL + "/logo.png"}
            alt="MahjSpace"
            className="mjti-footer__logo"
          />
          <div className="mjti-footer__tagline">{c.footer.tagline}</div>
          <div className="mjti-footer__links">
            <a href={c.footer.instagramUrl} target="_blank" rel="noreferrer">Instagram</a>
            <a href={c.footer.facebookUrl} target="_blank" rel="noreferrer">Facebook</a>
            <a href="?page=terms">Terms</a>
            <a href="?page=privacy">Privacy</a>
          </div>
          <div className="mjti-footer__contact">
            <a href={`mailto:${c.footer.contactEmail}`}>{c.footer.contactEmail}</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
